export const getRowPattern = (totalItems: number): number[] => {
  if (totalItems <= 4) {
    return Array.from({ length: totalItems }, () => 1);
  }

  if (totalItems === 5) {
    return [1, 2, 1, 1];
  }

  const rows: number[] = [1, 2, 1, 2];
  let remaining = totalItems - 6;

  while (remaining > 0) {
    if (remaining === 1) {
      rows.push(1);
      break;
    }

    if (remaining === 2) {
      rows.push(2);
      break;
    }

    if (remaining === 3) {
      rows.push(1, 2);
      break;
    }

    rows.push(1, 2);
    remaining -= 3;
  }

  return rows;
};
